export const VIDEO_UPLOAD_CONSTANTS = {
  POSTER_FIELD_NAME: 'poster_url',
  DEFAULT_TITLE: 'Add video',
  DEFAULT_SELECT_LABEL: 'SELECT FILE',
  PREVIEW_ALT: 'Video preview',
  UPLOAD_LABEL: 'Upload'
} as const;
